export function removeHttpsProtocol(url: string) {
    return url.replace(/^https:\/\//, '');
}
